export default __webpack_public_path__ + "static/media/background.69a3ebf4.jpg";